export const dynamicTemplate = (templateString: string, templateVariables: Record<string, any>) => {
  return templateString?.replace(/\${(.*?)}/g, (_, g) => templateVariables[g])
}
